import { useState } from "react";
import { toast } from "sonner";
import { Card, useSaveProfile } from "./ProfileCard";
import { Field, FormError, SubmitButton } from "./Field";
import { useAccount } from "@/context/AccountContext";
import { errorMessage } from "@/lib/api";
import { SHIP_COUNTRIES } from "@/lib/site";

const EMPTY = { recipient: "", line1: "", line2: "", postal_code: "", city: "", province: "", country: "IT", phone: "" };

const FIELDS = [
  { k: "recipient", l: "Destinatario", auto: "name", req: true, span: true },
  { k: "line1", l: "Indirizzo e numero civico", auto: "address-line1", req: true, span: true },
  { k: "line2", l: "Scala, interno, c/o (facoltativo)", auto: "address-line2", span: true },
  { k: "postal_code", l: "CAP", auto: "postal-code", req: true },
  { k: "city", l: "Città", auto: "address-level2", req: true },
  { k: "province", l: "Provincia", auto: "address-level1" },
  { k: "phone", l: "Telefono per il corriere", auto: "tel" },
];

export const AddressCard = () => {
  const { customer } = useAccount();
  const save = useSaveProfile();
  const [addr, setAddr] = useState({ ...EMPTY, recipient: customer.name, ...(customer.shipping_address || {}) });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await save({ shipping_address: addr });
      toast.success("Indirizzo salvato");
    } catch (err) {
      setError(errorMessage(err, "Controlla l'indirizzo: destinatario, via, CAP e città sono obbligatori."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Indirizzo di spedizione" index="02" testid="account-address-card">
      <form onSubmit={submit} className="grid gap-x-6 gap-y-5 sm:grid-cols-2">
        {FIELDS.map(({ k, l, auto, req, span }) => (
          <Field
            key={k}
            label={l}
            required={req}
            autoComplete={auto}
            value={addr[k]}
            onChange={(e) => setAddr({ ...addr, [k]: e.target.value })}
            testid={`account-address-${k.replace("_", "-")}-input`}
            className={span ? "sm:col-span-2" : ""}
          />
        ))}
        <label className="block">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">Paese</span>
          <select
            value={addr.country}
            onChange={(e) => setAddr({ ...addr, country: e.target.value })}
            data-testid="account-address-country-select"
            className="h-14 w-full border-b border-bone/25 bg-transparent text-base text-bone outline-none focus:border-acid"
          >
            {SHIP_COUNTRIES.map(([code, label]) => <option key={code} value={code} className="bg-ink">{label}</option>)}
          </select>
        </label>
        <div className="space-y-4 sm:col-span-2">
          <FormError error={error} testid="account-address-error" />
          <SubmitButton loading={loading} testid="account-address-save-button" loadingText="Salvo…">Salva indirizzo</SubmitButton>
        </div>
      </form>
    </Card>
  );
};
